import React from 'react';
import PropTypes from 'prop-types';

function Tabs(props) {
  const classNames = ['c-tabs'];
  if (props.wrapperClass)classNames.push(`${props.wrapperClass}`);
  if (props.format) classNames.push(`-${props.format}`);
  if (!props.format) classNames.push('-switcher');
  if (props.theme) classNames.push(`-${props.theme}`);
  const isDisabled = (value) => props.disabledValues && props.disabledValues.includes(value);
  return (
    <div className={classNames.join(' ')}>
      {props.label &&
        <span className="label">{props.label}</span>
      }
      <ul className="options">
        {props.options.map((option, key) => (
          <li
            className={`option ${option.value === props.value ? '-active' : ''} ${isDisabled(option.value) ? '-disabled' : ''}`}
            key={key}
            onClick={!isDisabled(option.value) && (() => props.onChange(option))}
          >
            {option.value !== 'both' && !option.noIcon &&
              <svg className={`icon -${option.value}`}><use xlinkHref={`#icon-${option.value}`}></use></svg>}
            <button className="tab-name" disabled={isDisabled(option.value)} >{option.label}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

Tabs.propTypes = {
  theme: PropTypes.string, // Set colors for different sectors
  format: PropTypes.string, // Define format circle or rect
  wrapperClass: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  noIcon: PropTypes.string,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  disabledValues: PropTypes.array
};

export default Tabs;



// WEBPACK FOOTER //
// ./app/components/common/Tabs.jsx